import React from 'react';
import { Redirect } from 'react-router-dom';
import pages from 'client/pages';

/* eslint-disable max-len */
const routes = [
  { path: '/', exact: true, component: pages.Home },
  { path: '/get-started', exact: true, component: pages.GetStarted },
  { path: '/signup-buyer-agent', exact: true, component: pages.BuyerSideAgentSignUpPage },
  { path: '/signup-agent', exact: true, component: pages.PartnerSignUp },
  { path: '/start', exact: true, component: pages.Onboarding },
  { path: '/start/switch-to-apartments', component: pages.SwitchToApartments },
  { path: '/explore', exact: true, component: pages.Listings },
  { path: '/explore/map', exact: true, component: pages.ListingsMap },
  { path: '/feed', exact: true, component: pages.SrFeedPage },
  { path: '/feed/:feedCategoryId/map', exact: true, component: pages.FeedCategoryMapPage },
  { path: '/feed/:feedCategoryId/map/:mapArea', exact: true, component: pages.FeedCategoryMapPage },
  { path: '/feed/:feedCategoryId', exact: true, component: pages.SrListviewPage },
  { path: '/feed/:feedCategoryId/:mapArea', exact: true, component: pages.SrListviewPage },
  { path: '/address-search', exact: true, component: pages.AddressSearch },
  { path: '/search', exact: true, component: pages.Search },
  { path: '/search/moveInDate', component: pages.FilterMoveInDate },
  { path: '/search/rentPriceRange', component: pages.FilterRentPriceRange },
  { path: '/search/squareFeet', component: pages.FilterSquareFeetRange },
  { path: '/search/:filterName', component: pages.Filter },
  { path: '/listing/:listingId/choose-tour-time', component: pages.ListingChooseTourTime },
  { path: '/listing/:listingId/photos', component: pages.ListingPhotos },
  { path: '/listing/:listingId/map', component: pages.ListingMap },
  { path: '/listing/:listingId/verify-phone', component: pages.VerifyPhonePage },
  { path: '/listing/:listingId/apartment-locator', component: pages.ListingApartmentLocator },
  { path: '/listing/:listingId/request-tour', component: pages.PrequalCompletedRequestTour },
  { path: '/listing/:listingId/request-tour-email', component: pages.RequestTourEmail },
  { path: '/listing/:listingId/self-tour/client-info', component: pages.SelfTourClientInfoPage },
  { path: '/listing/:listingId/self-tour/:stepId', component: pages.SelfTourMultiFamily },
  { path: '/listing/:listingId/self-tour', component: pages.SelfTourMultiFamily },
  { path: '/listing/:listingId', component: pages.Listing },
  { path: '/apartment/:apartmentId/photos', component: pages.ApartmentPhotosPage },
  { path: '/apartment/:apartmentId/map', component: pages.ApartmentMapPage },
  { path: '/apartment/:apartmentId', component: pages.ApartmentPage },
  {
    path: '/broker-listings-iframe/:listingManagementCompany',
    component: pages.BrokerListingsWidget,
  },
  { path: '/profile', exact: true, component: pages.RenterProfilePage },
  {
    path: '/profile/:userId/:listingId/public',
    exact: true,
    component: pages.RenterProfilePagePublic,
  },
  { path: '/join-sunroom-club', exact: true, component: pages.JoinSunroomClubPage },
  { path: '/join-sunroom-club/paid', exact: true, component: pages.SunroomClubMembershipPaidPage },
  {
    path: '/join-sunroom-club/thank-you',
    exact: true,
    component: pages.SunroomClubConfirmationPage,
  },
  {
    path: '/join-sunroom-club/questionnaire',
    exact: true,
    component: pages.SunroomClubQualificationFormPage,
  },
  { path: '/about-sunroom-select', exact: true, component: pages.SunroomSelectMarketingPage },
  { path: '/m/:partnerId', component: pages.PartnerAgentOwnerMarketingPage },
  { path: '/apply/:listingId', component: pages.ApplyPage },

  { path: '/tour', exact: true, component: pages.Tours },
  { path: '/tour/saved', exact: true, component: pages.Tours },
  { path: '/tour/completed', exact: true, component: pages.Tours },
  { path: '/tour/:tourId/cancel', component: pages.TourCancellation },
  { path: '/tour/:tourId/:listingId/choose-tour-time', component: pages.ListingChooseTourTime },

  { path: '/application/prequal-start', exact: true, component: pages.PrequalFormStartPage },
  {
    path: '/application/renter-profile/:userId/form',
    exact: true,
    component: pages.ApplicationFormPage,
  },
  {
    path: '/application/renter-profile/:userId/form-confirm',
    exact: true,
    component: pages.RenterProfileSubmittedPage,
  },

  { path: '/application/:userId/:listingId/starter', component: pages.ApplicationStarterPage },
  {
    path: '/application/:userId/:listingId/in-person-tour',
    component: pages.HouseholdConfirmInPersonTour,
  },
  { path: '/application/:userId/:listingId/move-in', component: pages.HouseholdConfirmMoveIn },
  {
    path: '/application/:userId/:listingId/invite-guarantor',
    component: pages.HouseholdInviteGuarantor,
  },
  {
    path: '/application/:userId/:listingId/invite-guarantor-sent',
    component: pages.HouseholdInviteGuarantorSent,
  },
  {
    path: '/application/:userId/:listingId/roommate-count',
    component: pages.HouseholdCollectRoommateCount,
  },
  {
    path: '/application/:userId/:listingId/roommate-info',
    component: pages.HouseholdCollectRoommateInfo,
  },
  {
    path: '/application/:userId/:listingId/invites',
    component: pages.HouseholdRoommateInviteLinksSent,
  },
  { path: '/application/:userId/:listingId/agent', component: pages.HouseholdBuyerSideAgentPage },

  { path: '/application/:userId/:listingId/start', component: pages.ApplicationStart },
  {
    path: '/application/:userId/:listingId/form',
    exact: true,
    component: pages.ApplicationFormPage,
  },
  {
    path: '/application/:userId/:listingId/form/:applicationId',
    component: pages.ApplicationFormPage,
  },
  { path: '/application/:userId/:listingId/pay-form', component: pages.ApplicationPaymentPage },
  { path: '/application/:userId/:listingId/pay', component: pages.ApplicationSubmittedPage },
  { path: '/application/payment', exact: true, component: pages.ApplicationSubmissionPaymentPage },
  {
    path: '/application/payment/thank-you',
    exact: true,
    component: pages.ApplicationSubmittedPage,
  },
  {
    path: '/security-deposit/:householdId/:listingId',
    component: pages.SecurityDepositPaymentPage,
  },

  {
    path: '/rental-application/:userId/:listingId/:stepId',
    component: pages.RentalApplicationPage,
  },

  { path: '/saved', component: pages.BookmarksPage },
  { path: '/download-mobile-app-link', exact: true, component: pages.PartnerDownloadMobileAppPage },
  { path: '/make-leasing-simple', exact: true, component: pages.PartnerMakeLeasingSimplePage },
  { path: '/faq', component: pages.Faq },
  { path: '/maintenance', component: pages.Maintenance },
  { path: '/faq-application', component: pages.FaqApplication },
  { path: '/faq-move-in-date', component: pages.FaqMoveInDate },
  { path: '/login', component: pages.Login },
  { path: '/user-token-login', component: pages.UserTokenLogin },
  { path: '/invite', component: pages.Login },
  { path: '/logout', component: pages.Logout },
  { path: '/reset-password', component: pages.ResetPassword },
  { path: '/reset-password-verify-code', component: pages.ResetPasswordVerifyCode },
  { path: '/reset-password-confirm', component: pages.ResetPasswordConfirm },
  { path: '/invite-guarantor', component: pages.RoommateSignup, exact: true },
  { path: '/invite-guarantor/verify-phone', component: pages.VerifyPhonePage },
  { path: '/invite-roommate', component: pages.RoommateSignup, exact: true },
  { path: '/invite-roommate/verify-phone', component: pages.VerifyPhonePage },
  { path: '/invited-to-apply', component: pages.RoommateSignup },
  { path: '/refer-renter', component: pages.ReferRenter },
  { path: '/user-map-area', component: pages.UserMapArea },
  {
    path: '/connect-bank/listing/:listingId/start',
    exact: true,
    component: pages.ConnectBankAccountStartPage,
  },
  {
    path: '/connect-bank/listing/:listingId/form',
    exact: true,
    component: pages.ConnectBankAccountFormPage,
  },
  {
    path: '/connect-bank/partner/:partnerId/start',
    exact: true,
    component: pages.ConnectBankAccountStartPage,
  },
  {
    path: '/connect-bank/partner/:partnerId/form',
    exact: true,
    component: pages.ConnectBankAccountFormPage,
  },
  { path: '/plaid/oauth', component: pages.PlaidOauthPage },

  { path: '/partner', exact: true, component: pages.PartnerOverviewRedirectPage },
  { path: '/partner/:partnerSlug', exact: true, component: pages.PartnerOverviewPage },
  {
    path: '/partner/:partnerSlug/listing/:listingId',
    exact: true,
    component: pages.PartnerListingPage,
  },
  {
    path: '/partner/:partnerSlug/listing/:listingId/edit',
    exact: true,
    component: pages.PartnerEditListingPage,
  },
  {
    path: '/partner/:partnerSlug/listing/:listingId/edit/move-in',
    component: pages.PartnerEditListingMoveInPage,
  },
  {
    path: '/partner/:partnerSlug/listing/:listingId/edit/property',
    component: pages.PartnerEditListingPropertyDetailsPage,
  },
  {
    path: '/partner/:partnerSlug/listing/:listingId/edit/showing-access',
    component: pages.PartnerEditListingShowingAccessPage,
  },
  {
    path: '/partner/:partnerSlug/listing/:listingId/edit/renter-pet-criteria',
    component: pages.PartnerEditListingRenterPetCriteriaPage,
  },
  {
    path: '/partner/:partnerSlug/listing/:listingId/edit/fee-settings',
    component: pages.PartnerEditListingFeeSettingsPage,
  },
  {
    path: '/partner/:partnerSlug/listing/:listingId/edit/admin',
    component: pages.PartnerEditListingAdminSettingsPage,
  },
  {
    path: '/partner/:partnerSlug/listing/:listingId/connect-bank/:householdListingId',
    component: pages.PartnerListingHouseholdConnectBankPage,
  },
  {
    path: '/partner/:partnerSlug/listing/:listingId/approve/:householdListingId',
    component: pages.PartnerListingHouseholdApprovalPage,
  },
  {
    path: '/partner/:partnerSlug/apartment/:apartmentId',
    exact: true,
    component: pages.PartnerApartmentPage,
  },
  {
    path: '/partner/:partnerSlug/market-property',
    exact: true,
    component: pages.MarketingPartnerListingPage,
  },
  {
    path: '/partner/:partnerSlug/market-sunrise-property',
    exact: true,
    component: pages.MarketingPartnerSunriseListingPage,
  },
  {
    path: '/partner/:partnerSlug/market-screening-property',
    exact: true,
    component: pages.TenantScreeningMarketProperty,
  },
  {
    path: '/partner/:partnerSlug/market-property/:marketingPartnerListingId/invite/:landlordId',
    exact: true,
    component: pages.MarketingPartnerListingInviteLandlord,
  },
  {
    path: '/partner/:partnerSlug/market-property/:marketingPartnerListingId',
    exact: true,
    component: pages.MarketingPartnerListingPage,
  },
  { path: '/partner/:partnerSlug/settings', exact: true, component: pages.PartnerSettingsPage },
  {
    path: '/partner/:partnerSlug/settings/applications',
    exact: true,
    component: pages.PartnerSettingsApplicationsPage,
  },
  {
    path: '/partner/:partnerSlug/settings/listing',
    exact: true,
    component: pages.PartnerSettingsListingPage,
  },
  {
    path: '/partner/:partnerSlug/settings/banks',
    exact: true,
    component: pages.PartnerSettingsBanksPage,
  },
  {
    path: '/partner/:partnerSlug/settings/marketing-sunrise',
    exact: true,
    component: pages.PartnerSettingsMarketingSunrisePage,
  },
  {
    path: '/partner/:partnerSlug/settings/approval-flow',
    exact: true,
    component: pages.PartnerSettingsApprovalFlowPage,
  },
  {
    path: '/partner/:partnerSlug/settings/admin',
    exact: true,
    component: pages.PartnerSettingsAdminSettingsPage,
  },
  { path: '/partner/:partnerSlug/billing', exact: true, component: pages.PartnerBillingPage },
  {
    path: '/partner/:partnerSlug/marketing-listing/:marketingPartnerListingId/:listingStatus',
    exact: true,
    component: pages.MarketingPartnerListingStatus,
  },
  { path: '/partner/:partnerSlug/reports', exact: true, component: pages.PartnerReportsPage },
  {
    path: '/partner/:partnerSlug/utility-profit',
    exact: true,
    component: pages.SunroomUtilityPartnerOverviewPage,
  },

  {
    path: '/utility-profit/admin',
    exact: true,
    component: pages.UtilityProfit.UtilityProfitAdminPage,
  },
  {
    path: '/utility-profit/admin/address',
    exact: true,
    component: pages.UtilityProfit.UtilityProfitAdminRegisterAddressPage,
  },
  {
    path: '/utility-profit/admin/bcc-reminders',
    exact: true,
    component: pages.UtilityProfit.UtilityProfitAdminBccReminderPage,
  },
  {
    path: '/utility-profit/admin/address/processing/:addressId',
    exact: true,
    component: pages.UtilityProfit.UtilityProfitAdminProcessingAddressPage,
  },
  {
    path: '/utility-profit/admin/processing/:utilityActivationShortId',
    exact: true,
    component: pages.UtilityProfit.UtilityProfitAdminProcessingActivationPage,
  },
  {
    path: '/utility-profit/admin/scraper-logs',
    exact: true,
    component: pages.UtilityProfit.UtilityProfitAdminListingsScraperLogGroupsPage,
  },
  {
    path: '/utility-profit/admin/dashboard/accounting',
    exact: true,
    component: pages.UtilityProfit.UtilityProfitAdminAccountingDashboardPage,
  },
  {
    path: '/utility-profit/admin/dashboard/accounting-non-internet',
    exact: true,
    component: pages.UtilityProfit.UtilityProfitAdminAccountingNonInternetDashboardPage,
  },
  {
    path: '/utility-profit/admin/dashboard/mapping-hitlist',
    exact: true,
    component: pages.UtilityProfit.UtilityProfitMappingHitlist,
  },
  {
    path: '/utility-profit/admin/dashboard/pms-processing-tool',
    exact: true,
    component: pages.UtilityProfit.UtilityProfitAdminPmsProcessingToolPage,
  },
  {
    path: '/utility-profit/admin/dashboard/order-hitlist/:orderType',
    exact: true,
    component: pages.UtilityProfit.UtilityProfitOrderHitlist,
  },
  {
    path: '/utility-profit/admin/dashboard/order-hitlist',
    exact: true,
    component: () => (
      <Redirect to="/utility-profit/admin/dashboard/order-hitlist/non-delayed-orders" />
    ),
  },
  {
    path: '/utility-profit/admin/automatic-orders',
    exact: true,
    component: pages.UtilityProfit.UtilityProfitAutomaticOrdersPage,
  },
  {
    path: '/utility-profit/admin/automatic-orders/:orderId',
    exact: true,
    component: pages.UtilityProfit.UtilityProfitAutomaticOrdersPageDetails,
  },
  {
    path: '/utility-profit/admin/providers',
    exact: true,
    component: pages.UtilityProfit.UtilityProfitAdminProvidersPage,
  },

  {
    path: '/utility-profit',
    exact: true,
    component: pages.UtilityProfit.UtilityProfitRedirectPage,
  },
  {
    path: '/utility-profit/signup',
    exact: true,
    component: pages.UtilityProfit.UtilityProfitPartnerSignUpPage,
  },
  {
    path: '/utility-profit/login',
    exact: true,
    component: pages.UtilityProfit.UtilityProfitLoginPage,
  },
  { path: '/utility-profit/reset-password', component: pages.Utility.UtilityResetPasswordPage },
  {
    path: '/utility-profit/reset-password-verify-code',
    component: pages.Utility.UtilityResetPasswordVerifyCode,
  },
  {
    path: '/utility-profit/reset-password-confirm',
    component: pages.Utility.UtilityResetPasswordConfirmPage,
  },
  {
    path: '/utility-profit/activate-partner-user',
    exact: true,
    component: pages.UtilityProfit.UtilityProfitActivatePartnerUserRedirectPage,
  },
  {
    path: '/utility-profit/:partnerSlug',
    exact: true,
    component: pages.UtilityProfit.UtilityPartnerOverviewPage,
  },
  {
    path: '/utility-profit/:partnerSlug/settings',
    exact: true,
    component: pages.UtilityProfit.UtilityPartnerSettingsPage,
  },
  {
    path: '/utility-profit/:partnerSlug/settings/billing',
    exact: true,
    component: pages.UtilityProfit.UtilityPartnerSettingsBillingPage,
  },
  {
    path: '/utility-profit/:partnerSlug/settings/tenant',
    exact: true,
    component: pages.UtilityProfit.UtilityPartnerSettingsTenantPage,
  },
  {
    path: '/utility-profit/:partnerSlug/settings/team',
    exact: true,
    component: pages.UtilityProfit.UtilityPartnerSettingsTeamManagementPage,
  },
  {
    path: '/utility-profit/:partnerSlug/settings/banks',
    exact: true,
    component: pages.UtilityProfit.UtilityPartnerSettingsBanks,
  },
  {
    path: '/utility-profit/:partnerSlug/settings/partner',
    exact: true,
    component: pages.UtilityProfit.UtilityPartnerSettingsPartnerPage,
  },
  {
    path: '/utility-profit/:partnerSlug/connect-bank',
    exact: true,
    component: pages.UtilityProfit.UtilityPartnerConnectBankPage,
  },
  {
    path: '/utility-profit/:partnerSlug/internet-amenity',
    exact: true,
    component: pages.UtilityProfit.UtilityProfitPartnerReportsPage,
  },

  {
    path: '/utility-setup/session',
    exact: true,
    component: pages.UtilitySetup.UtilitySetupRedirectPage,
  },
  {
    path: '/utility-setup/:partnerSlug',
    exact: true,
    component: pages.UtilitySetup.UtilitySetupAddressSearchPage,
  },
  {
    path: '/utility-setup/:partnerSlug/login',
    exact: true,
    component: pages.UtilitySetup.UtilitySetupLoginPage,
  },
  {
    path: '/utility-setup/:partnerSlug/login/:addressId',
    exact: true,
    component: pages.UtilitySetup.UtilitySetupLoginPage,
  },
  {
    path: '/utility-setup/:partnerSlug/verify-phone/:addressId',
    exact: true,
    component: pages.UtilitySetup.UtilitySetupVerifyPhonePage,
  },
  {
    path: '/utility-setup/:partnerSlug/reset-password',
    component: pages.Utility.UtilityResetPasswordPage,
  },
  {
    path: '/utility-setup/:partnerSlug/reset-password-verify-code',
    component: pages.Utility.UtilityResetPasswordVerifyCode,
  },
  {
    path: '/utility-setup/:partnerSlug/reset-password-confirm',
    component: pages.Utility.UtilityResetPasswordConfirmPage,
  },
  {
    path: '/utility-setup/:partnerSlug/signup/:addressId',
    exact: true,
    component: pages.UtilitySetup.UtilitySetupSignupPage,
  },
  {
    path: '/utility-setup/:partnerSlug/:utilityActivationShortId',
    exact: true,
    component: pages.UtilitySetup.UtilitySetupOverviewPage,
  },
  {
    path: '/utility-setup/:partnerSlug/:utilityActivationShortId/:utilityTypeLabel/provider',
    exact: true,
    component: pages.UtilitySetup.UtilitySetupProviderPage,
  },
  {
    path: '/utility-setup/:partnerSlug/:utilityActivationShortId/:utilityTypeLabel/plan',
    exact: true,
    component: pages.UtilitySetup.UtilitySetupProviderPlanPage,
  },
  {
    path:
      '/utility-setup/:partnerSlug/:utilityActivationShortId/:utilityTypeLabel/plan-no-contract',
    exact: true,
    component: pages.UtilitySetup.UtilitySetupProviderPlanNoContractPage,
  },
  {
    path:
      '/utility-setup/:partnerSlug/:utilityActivationShortId/:utilityTypeLabel/plan/:utilityProviderId/new-customer-deals',
    exact: true,
    component: pages.UtilitySetup.UtilitySetupProviderPlanCustomerDealsPage,
  },
  {
    path:
      '/utility-setup/:partnerSlug/:utilityActivationShortId/:utilityTypeLabel/plan/:utilityProviderId/:utilityProviderPlanId/:utilityProviderPlanVariantId',
    exact: true,
    component: pages.UtilitySetup.UtilitySetupProviderPlanConfirmationPage,
  },
  {
    path:
      '/utility-setup/:partnerSlug/:utilityActivationShortId/:utilityTypeLabel/plan/:utilityProviderId/:utilityProviderPlanId',
    exact: true,
    component: pages.UtilitySetup.UtilitySetupProviderPlanConfirmationPage,
  },
  {
    path: '/utility-setup/place-order/:partnerSlug/:utilityActivationShortId',
    exact: true,
    component: pages.UtilitySetup.UtilitySetupPlaceOrderPage,
  },

  { path: '/owner', exact: true, component: pages.LandlordOverviewRedirectPage },

  { path: '/admin', exact: true, component: pages.Admin },
  { path: '/admin/review-partners', exact: true, component: pages.ReviewPartners },
  { path: '/admin/tours/:tourId/add-to-tour', exact: true, component: pages.AdminAddToTourPage },
  { path: '/admin/tours/:tourStatePath', exact: true, component: pages.AdminToursPage },
  {
    path: '/admin/tours/:tourStatePath/user/:userId',
    exact: true,
    component: pages.AdminToursPage,
  },
  {
    path: '/admin/tours/:tourStatePath/:tourStateSubPath',
    exact: true,
    component: pages.AdminToursPage,
  },

  { path: '/agent/tours', exact: true, component: pages.AgentToursPage },
  {
    path: '/agent/tours/:agentTourId/:listingId/showing-failed',
    component: pages.AgentShowingFailedPage,
  }, // eslint-disable-line max-len
  { path: '/agent/map', exact: true, component: pages.AgentMapPage },
  { path: '/agent/map/:agentUserId', component: pages.AgentMapPage },
  { path: '/agent/:tourId/search', exact: true, component: pages.AgentSearchPage },
  { path: '/agent/:tourId/search/:filterName', component: pages.AgentSearchFilterPage },
  { path: '/agent/call', component: pages.AgentCallPage, exact: true },
  { path: '/agent/leads', component: pages.AgentLeadsPage, exact: true },
  {
    path: '/agent/locator-leaderboard',
    component: pages.ApartmentLocatorLeaderboardPage,
    exact: true,
  },
  { path: '/agent/tour-guide-leaderboard', component: pages.TourGuideLeaderboardPage, exact: true },
  { path: '/agent/leads/:leadStatus', component: pages.AgentLeadsPage, exact: true },
  { path: '/agent/lead/:renterUserId', component: pages.AgentLeadPage, exact: true },
  { path: '/agent/lead/:renterUserId/edit', component: pages.AgentLeadEditPage, exact: true },
  { path: '/agent/lead/:renterUserId/archive', component: pages.ArchiveLeadPage, exact: true },
  {
    path: '/agent/lead/:renterUserId/activity',
    component: pages.AgentLeadActivityPage,
    exact: true,
  },
  { path: '/agent/add-lead', component: pages.AgentAddLeadPage, exact: true },
  { path: '/agent/call/:userPhone', component: pages.AgentCallPage, exact: true },
  { path: '/agent/locator-profile', component: pages.ApartmentLocatorProfilePage, exact: true },
  { path: '/agent/tour-guide-profile', component: pages.TourGuideProfilePage, exact: true },
  { path: '/agent/feed', component: pages.AgentFeedPage, exact: true },

  {
    path: '/admin/app-processing/:householdListingId',
    exact: true,
    component: pages.ApplicationAssemblyLinePage,
  },
  { path: '/admin/household-overview', exact: true, component: pages.HouseholdKanbanBoardPage },
  { path: '/admin/household', exact: true, component: pages.HouseholdDashboardPage },
  {
    path: '/admin/household/:householdStatePath',
    exact: true,
    component: pages.HouseholdDashboardPage,
  },
  {
    path: '/admin/household/:householdStatePath/:userId',
    exact: true,
    component: pages.HouseholdDashboardPage,
  },
  {
    path: '/admin/household-admin-assignment-control',
    component: pages.AdminHouseholdRoundRobinAssignmentControl,
    exact: true,
  },
  {
    path: '/admin/application/:userId/:listingId',
    exact: true,
    component: pages.HouseholdApplicationEdit,
  },
  {
    path: '/admin/application/:userId/:listingId/:applicationId',
    component: pages.HouseholdApplicationEdit,
  },
  {
    path: '/admin/locator-leaderboard',
    component: pages.ApartmentLocatorLeaderboardPage,
    exact: true,
  },
  { path: '/admin/tour-guide-leaderboard', component: pages.TourGuideLeaderboardPage, exact: true },
  { path: '/admin/user-tour-creator', component: pages.AdminUserTourCreatorPage, exact: true },
  {
    path: '/admin/partner-listings-scraper',
    component: pages.AdminPartnerListingsScraperPage,
    exact: true,
  },
  {
    path: '/admin/tour-guide-schedules',
    component: pages.AdminTourGuideSchedulesPage,
    exact: true,
  },
  {
    path: '/admin/partner-tenant-screening-criteria',
    component: pages.AdminPartnerTenantScreeningCriteriaPage,
    exact: true,
  },
  { path: '/admin/partner-sales', component: pages.AdminPartnerSalesPage, exact: true },
  { path: '/admin/lead/:rentlinxLeadId', exact: true, component: pages.RentlinxLeadPage },

  { path: '/admin/pinned', exact: true, component: pages.AdminPinnedListingsPage },
  { path: '/admin/edit-listing', component: pages.AdminListingEditPage },
  { path: '/admin/edit-user', component: pages.AdminUserEditPage },
  { path: '/admin/tour-times', exact: true, component: pages.AdminTourTimesPage },
  {
    path: '/admin/write-push-notification',
    exact: true,
    component: pages.AdminTestPushNotification,
  },
  { path: '/admin/front-channels', exact: true, component: pages.AdminFrontChannelsPage },
  { path: '/admin/deployments', exact: true, component: pages.AdminDeployments },
  { path: '/admin/redirections', exact: true, component: pages.AdminRedirectionsPage },
  {
    path: '/admin/apartment-complex-unit-groups',
    exact: true,
    component: pages.AdminApartmentComplexUnitGroups,
  },
  { path: '/admin/listings', exact: true, component: pages.AdminSrListingsPage },
  { path: '/admin/listings/new', exact: true, component: pages.AdminSrListingEditPage },
  { path: '/admin/listings/edit/:listingId', exact: true, component: pages.AdminSrListingEditPage },
  { path: '/admin/apartments', exact: true, component: pages.AdminApartmentsPage },
  { path: '/admin/apartments/:apartmentId', exact: true, component: pages.AdminApartmentPage },
  { path: '/admin/going-to-market', exact: true, component: pages.AdminGoingToMarketPage },
  { path: '/admin/going-to-market-v2', exact: true, component: pages.AdminGoingToMarketPageV2 },
  { path: '/admin/move-ins', exact: true, component: pages.AdminMoveInsPage },
  {
    path: '/admin/lease-draft/:householdListingId',
    exact: true,
    component: pages.AdminLeaseDraftHelperPage,
  },
  { path: '/admin/lease-draft-config', exact: true, component: pages.AdminLeaseDraftConfigPage },
  { path: '/admin/listing-vitals', exact: true, component: pages.AdminListingVitalsPage },

  {
    path: '/admin/finances/invoices/:invoiceViewShortId',
    exact: true,
    component: pages.FinancesInvoicesPage,
  },
  {
    path: '/admin/finances/locator-commission-structures',
    exact: true,
    component: pages.FinancesLocatorCommissionStructuresPage,
  },
  { path: '/admin/finances/deposits', exact: true, component: pages.FinancesDepositsPage },
  {
    path: '/admin/finances/leases/:leaseViewShortId',
    exact: true,
    component: pages.FinancesLeasesPage,
  },
  {
    path: '/admin/finances/locator-commissions',
    exact: true,
    component: pages.FinancesLocatorCommissionsPage,
  },

  { path: '/admin/sunlocks', exact: true, component: pages.SunlocksDashboardPage },
  { path: '/admin/codebox', exact: true, component: pages.CodeboxDashboardPage },

  { path: '/admin/hitlist', exact: true, component: pages.HitlistPage },

  { path: '/admin/review-identity', exact: true, component: pages.AdminManualIdVerification },

  { path: '/locatortours', exact: true, component: pages.LocatorToursLandingPage },
  { path: '/locatortours/:apartmentId', exact: true, component: pages.LocatorToursApartmentPage },
  {
    path: '/locatortours/:apartmentId/guest-card',
    exact: true,
    component: pages.LocatorToursGuestCardPage,
  },
  {
    path: '/locatortours/:apartmentId/lockbox',
    exact: true,
    component: pages.LocatorToursLockboxCodePage,
  },
  {
    path: '/locatortours/:apartmentId/success',
    exact: true,
    component: pages.LocatorToursSuccessPage,
  },
  {
    path: '/locatortours/:apartmentId/feedback/:tourId',
    exact: true,
    component: pages.LocatorToursFeedbackPage,
  }, // eslint-disable-line max-len

  { path: '/closing-docs-test', exact: true, component: pages.SrClosingDocsProofOfConceptPage },
  { path: '/closing-docs-poc', exact: true, component: pages.SrClosingDocsProofOfConceptPage },
  { path: '/verifast-poc', exact: true, component: pages.SrVerifastProofOfConceptPage },
  { path: '/finicity-poc', exact: true, component: pages.SrFinicityProofOfConceptPage },
  { path: '/pinwheel-poc', exact: true, component: pages.SrPinwheelProofOfConceptPage },

  { path: '/sunsetup/inventory', exact: true, component: pages.AdminInventoryPage },
  { path: '/sunsetup/orders', exact: true, component: pages.AdminOrdersOverviewPage },
  { path: '/sunsetup/driver', exact: true, component: pages.SunSetupDriverRedirectPage },
  { path: '/sunsetup/driver/create', exact: true, component: pages.DriverCreate },
  {
    path: '/sunsetup/drivers/:driverId/orders',
    exact: true,
    component: pages.SunSetupDriverOrdersPage,
  },
  {
    path: '/sunsetup/drivers/:driverId/orders/:orderId',
    exact: true,
    component: pages.SunSetupDriverOrderPage,
  },
  {
    path: '/sunsetup/drivers/:driverId/orders/:orderId/jobs/:jobId',
    exact: true,
    component: pages.SunSetupDriverJobPage,
  },
  { path: '/sunsetup/orders/create', exact: true, component: pages.SunSetupUpsertJobOrderPage },
  {
    path: '/sunsetup/orders/edit/:jobOrderId',
    exact: true,
    component: pages.SunSetupUpsertJobOrderPage,
  },
  {
    path: '/sunsetup/listing-orders/:listingId',
    exact: true,
    component: pages.ListingJobOrdersPage,
  },
  { path: '/sunsetup/register-item', exact: true, component: pages.SunSetupItemRegisterPage },
  { path: '/pdf-generator/:pdfComponentId', exact: true, component: pages.SrPdfGenerator },

  {
    path: '/photographer/edit-listing/:listingId',
    exact: true,
    component: pages.AdminSrListingEditPage,
    params: {
      isPhotographerRoute: true,
    },
  },

  // Redirections.
  {
    path: '/apply-now',
    exact: true,
    component: () => (
      <Redirect to="/tour?utm_source=tour&utm_medium=sms&utm_campaign=postTourApply" />
    ),
  },

  // WARNING(@d-oliveros): The "Not found" route has to be the last route in the array. Routes below this route will not be matched.
  { component: pages.NotFound },
];
/* eslint-enable max-len */

export default routes;
